import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Box,
  Typography,
  IconButton,
  Link,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';

const DownloadAppModal = ({ open, onClose }) => {
  const androidQR = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://play.google.com/store/apps/details?id=com.doopus.kbean';
  const iosQR = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://apps.apple.com/pk/app/kbean/id1456375088';

  const androidLink = 'https://play.google.com/store/apps/details?id=com.doopus.kbean';
  const iosLink = 'https://apps.apple.com/pk/app/kbean/id1456375088';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 600, fontSize: 22 }}>
        Download Our Mobile App
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 16, top: 16 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={4} justifyContent="center">
          {/* Android */}
          <Grid item xs={12} sm={6} textAlign="center">
            <AndroidIcon fontSize="large" sx={{ color: '#3DDC84' }} />
            <Typography variant="subtitle1" fontWeight={600} mt={1}>
              Android
            </Typography>
            <Box
              component="img"
              src={androidQR}
              alt="Android QR"
              sx={{
                mt: 1,
                width: 150,
                height: 150,
                display: 'block',
                margin: '0 auto'  // ✅ Center align image
              }}
            />
            <Link
              href={androidLink}
              target="_blank"
              rel="noopener"
              underline="hover"
              sx={{ display: 'block', mt: 1 }}
            >
              Open in Play Store
            </Link>
          </Grid>

          {/* iOS */}
          <Grid item xs={12} sm={6} textAlign="center">
            <AppleIcon fontSize="large" sx={{ color: '#000000' }} />
            <Typography variant="subtitle1" fontWeight={600} mt={1}>
              iOS
            </Typography>
            <Box
              component="img"
              src={iosQR}
              alt="iOS QR"
              sx={{
                mt: 1,
                width: 150,
                height: 150,
                display: 'block',
                margin: '0 auto'  // ✅ Center align image
              }}
            />
            <Link
              href={iosLink}
              target="_blank"
              rel="noopener"
              underline="hover"
              sx={{ display: 'block', mt: 1 }}
            >
              Open in App Store
            </Link>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadAppModal;
